import Button from '@root/gatsby-contentful-core/src/components/button';
import Market from '@root/core/src/models/market';
import Modal from '@root/gatsby-contentful-core/src/components/modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import car from '@root/triage/src/assets/grey-car.png';
import { Colors } from '@root/core/src/utils/styles';
import { StyleSheet } from '@root/core/src/utils/styles';
import { bold, regular, semiBold } from '@root/brand/src/assets/fonts/root-sans/emotion';
import { toRgba } from '@root/gatsby-contentful-core/src/utils/colors';

export default function AgentsUnsupportedMarketModal({
  isShowing,
  market,
  onDismiss,
}) {
  return (
    <Modal
      renderCloseButton
      isShowing={isShowing}
      name={'joinroot-agents-isa-not-supported-modal'}
      onClose={onDismiss}
    >
      <div css={styles.imageContainer}>
        <img
          alt={'grey car'}
          css={styles.image}
          src={car}
        />
      </div>
      <h1 css={styles.header}>
        {`We’re working hard to get in ${Market.MAPPING[market]}`}
      </h1>
      <p css={styles.text}>
        Root isn’t available yet in your state. Please check back soon.
      </p>
      <Button
        css={styles.continueButton}
        onClick={onDismiss}
      >
        Got it
      </Button>
    </Modal>
  );
}

const styles = StyleSheet.create({
  header: {
    fontSize: 32,
    marginBottom: 20,
    ...bold(),
    ...Responsive.lessThanSm({
      fontSize: 28,
    }),
  },
  text: {
    marginBottom: 20,
    fontSize: 18,
    ...regular(),
  },
  continueButton: {
    marginTop: 30,
    marginBottom: 10,
    width: '100%',
    ...semiBold(),
    ...Responsive.lessThanSm({
      marginBottom: 20,
    }),
    '&:hover': {
      boxShadow: `0 8px 6px -6px ${toRgba(Colors.nearBlack(), .3)}`,
    },
    transition: 'all 300ms cubic-bezier(0.37, 0, 0.28, 1)',
  },
  image: {
    maxWidth: '90%',
    marginBottom: 24,
  },
  imageContainer: {
    textAlign: 'center',
  },
});

AgentsUnsupportedMarketModal.propTypes = {
  isShowing: PropTypes.bool,
  market: PropTypes.string,
  onDismiss: PropTypes.func,
};
